import { useMemo } from 'react';
import { useActionButtonContext } from '../context/action-button-context';
import { CompanyTableInfo } from '../feature/search-table-company';
import { PeopleTableInfo } from '../feature/search-table-people';
import { SearchType } from '../types';
import { useSaveRecord } from './use-save-record';

export function useIsItemSaving(
  item?: PeopleTableInfo | CompanyTableInfo,
  searchType?: SearchType
) {
  // Determine the correct search type - prefer explicit type, then infer from item (People has 'company'), fallback to Company
  const effectiveSearchType =
    searchType ??
    (item && 'company' in item ? SearchType.People : SearchType.Company);

  const api = useSaveRecord(effectiveSearchType);
  const { isItemProcessing } = useActionButtonContext();

  const saving = useMemo(() => {
    const contextLoading = isItemProcessing
      ? isItemProcessing({
          id: item?.id ?? '',
          type: 'SAVING',
        })
      : false;

    if (api.isLoading || contextLoading) return true;

    return false;
  }, [api.isLoading, item, isItemProcessing]);

  return { saving };
}
